import axios, { AxiosResponse } from 'axios'
import parse from 'html-react-parser'
import { useContext, useEffect, useState } from 'react'
import images from '../../../assets/img/images'
import catchError from '../../../components/global/CatchError'
import Loader from '../../../components/global/Loader'
import Title from '../../../components/global/Title'
import { sweetAlertSuccess } from '../../../components/sweetalert/Alert'
import Table from '../../../components/table/Table'
import { SERVER_URL, apiHeader } from '../../../config'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import { useVerifyAdminToken } from '../../../hooks/useVerifyAdminToken'
import { serverFile } from '../../../services/file.service'
import { NewsModel, NewsType, helperNewsType } from '../../../types/news.type'
import { AdminContainer, LinkBtn, TitleWrapper } from '../users/AdminUsers'

const getServerFile = (newsItem: NewsModel) => (newsItem.image ? serverFile(newsItem.image) : '')
const filterValue = (news: NewsModel[], res: AxiosResponse<any, any>) =>
    news.filter((newsData) => newsData.id !== res.data.id)

const AdminNews = () => {
    const user = useContext(UserContext)
    const [news, setNews] = useState<NewsModel[] | undefined>(undefined)

    const verifyToken = useVerifyAdminToken()
    const lng = useLangSelected()

    const [currentLang, setCurrentLang] = useState(lng)

    const tableHeader = ['#', 'Titre', 'Description', 'Type', 'Image', 'Lien', '', '']

    useEffect(() => {
        verifyToken()
        if (!news || currentLang !== lng) {
            setCurrentLang(lng)
            axios
                .post(`${SERVER_URL}/news/all`, { lng }, apiHeader(user.tokenAdmin))
                .then(({ data }) => {
                    setNews(
                        data.map((newsItem: NewsModel) => ({
                            id: newsItem.id,
                            title: newsItem.title,
                            description: parse(newsItem.description),
                            type: helperNewsType(newsItem.type),
                            image: newsItem.type === NewsType.MEETING ? images.reunion : getServerFile(newsItem),
                            link: newsItem.link,
                            edit: `/${lng}/bva-admin/articles/${newsItem.id}`,
                            remove: true,
                        }))
                    )
                })
                .catch((err) =>
                    catchError(err.response.data, () => {
                        localStorage.removeItem('tokenAdmin')
                        user.adminData = undefined
                        window.location.reload()
                    })
                )
        }
    }, [news, user, lng])

    if (!news) return <Loader />

    const deleteById = (id: number) => {
        verifyToken()
        axios
            .delete(`${SERVER_URL}/news/${id}`, apiHeader(user.tokenAdmin))
            .then((res) => {
                sweetAlertSuccess('La suppression de cette article est réussi').then(() => {
                    setNews([...filterValue(news, res)])
                })
            })
            .catch((err) =>
                catchError(err.response.data, () => {
                    localStorage.removeItem('tokenAdmin')
                    user.adminData = undefined
                    window.location.reload()
                })
            )
    }

    return (
        <>
            <TitleWrapper>
                <Title>Articles</Title>
                <LinkBtn to={`/${lng}/bva-admin/articles/creer`} className="btn btn-primary mb-2">
                    Créer
                </LinkBtn>
            </TitleWrapper>
            <AdminContainer>
                <Table tableData={news} tableHeader={tableHeader} deleteById={deleteById} />
            </AdminContainer>
        </>
    )
}

export default AdminNews
